import React from 'react';
import PriceHistoryChart from './PriceHistoryChart';

export default function GoldChart(props) {
  return <PriceHistoryChart {...props} />;
}
